import { PagingBody } from "../common/interfaces/pagingParam.interface"
import { SearchConditionBody } from "../common/interfaces/searchConditionParam"
import { AxiosAuth } from "./config/axiosAuth.instance"

export interface GetManagementUserChargeHistoryPayloadAPIInterface
   extends PagingBody,
      SearchConditionBody {}

export const getManagementUserChargeHistoryAPI = (
   payload: GetManagementUserChargeHistoryPayloadAPIInterface
) => {
   return AxiosAuth.post("transaction/admin", payload)
      .then((response) => ({ response }))
      .catch((error) => ({ error }))
}
